/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
import { ActiveParameters, IConditionals } from 'types';
import { IParameter, IParameterList, IRFQEmailParameterGroup } from '../../server/types';

const mapParameters = (
  parameters: Record<string, Pick<IParameter, 'displayName' | 'type' | 'value'>>,
  parameterList: IParameterList[]
) => {
  const paramValues = parameterList.reduce((groupsAcc: IRFQEmailParameterGroup[], { pList, title }) => {
    const groupedParameters = pList.reduce((paramsAcc, key) => {
      if (!parameters[+key]) return paramsAcc;

      const { displayName, type, value } = parameters[+key];

      let parsedValue = value;

      if (type === 'numeric') {
        // TODO: Not quite sure what this regex is doing so can't test
        parsedValue = value.replace(/\D\\./g, '');
      }

      if (value === 'true' || value === 'false') parsedValue = value === 'true' ? 'Yes' : 'No';

      return {
        ...paramsAcc,
        [displayName]: parsedValue,
      };
    }, {});

    return [...groupsAcc, { title, parameters: groupedParameters }];
  }, []);

  return paramValues;
};

export const getParamSpecial = (propVal: boolean | string) => {
  let value;
  if (typeof propVal === 'boolean') {
    switch (propVal) {
      case true:
        value = true;
        break;
      default:
        value = false;
        break;
    }
  } else {
    switch (propVal) {
      case 'true' || 'True':
        value = true;
        break;
      case 'false' || 'False':
        value = false;
        break;
      default:
        value = propVal;
    }
  }

  return value;
};

export const getParamInventor = (
  value: string,
  type: string,
  values: { displayName: string; value: string | boolean }[]
) => {
  if (typeof value === 'boolean') {
    return value;
  }

  if (!value) {
    return '';
  }

  if (type === 'numeric' && typeof value === 'string') {
    return value.replace(/[^\d.-]/g, '');
  }

  const valueLowerCase = value.toLowerCase();

  if (valueLowerCase === 'true' || valueLowerCase === 'false') return valueLowerCase === 'true';

  const typeValues = Object.values(values).find(({ displayName }) => displayName.toLowerCase() === valueLowerCase);
  if (type === 'boolean') {
    return typeValues?.value;
  }

  if (type === 'text') {
    return typeValues?.value || value;
  }

  return value;
};

export const getParamsInventor = (parameters: ActiveParameters) => {
  let params = null;

  for (const property in parameters) {
    const { values, type, value, name } = parameters[property];
    const paramValue = getParamInventor(value, typeof type === 'string' ? type : '', values ?? []);

    const parameter = { [name]: paramValue };
    if (params == null) params = {};
    Object.assign(params, parameter);
  }
  return params;
};

export const getParamsSpecial = (parameters: { [x: string]: { name: string; type: string; value: string } }) => {
  let params = null;
  for (const property in parameters) {
    if (parameters[property]) {
      const propVal = parameters[property].value;
      const value = getParamSpecial(propVal);
      const parameter = { [property]: value };
      if (params == null) params = {};
      Object.assign(params, parameter);
    }
  }
  return params;
};

export const getSelectParams = (
  parameters: {
    [x: string]: {
      onConditions: IConditionals;
      inputType: string;
      isPreloaded: boolean;
      name: string;
      values: { [x: string]: { displayName: string; value: string } };
    };
  },
  startIndices: { [x: string]: string } | null | undefined
) => {
  let params = {};
  const keys = Object.keys(parameters);
  keys.forEach((key) => {
    const { inputType } = parameters[key];
    const { isPreloaded } = parameters[key];
    const { name } = parameters[key];

    if (inputType === 'select' && isPreloaded) {
      let startIndex;
      if (startIndices === null || startIndices === undefined) {
        startIndex = 0;
      } else {
        startIndex = startIndices[key];
        if (startIndex === null || startIndex === undefined) {
          startIndex = 0;
        }
      }

      const values: string[] = [];
      Object.keys(parameters[key].values).map((valKey) => {
        const { value } = parameters[key].values[valKey];
        return values.push(value);
      });

      if (parameters[key].onConditions !== undefined) {
        const { expressionList } = parameters[key].onConditions;
        const { expressions } = parameters[key].onConditions;
        params = {
          ...params,
          [key]: {
            name,
            values,
            startIndex: [startIndex],
            expressionList,
            expressions,
          },
        };
      } else {
        params = {
          ...params,
          [key]: {
            name,
            values,
            startIndex: [startIndex],
          },
        };
      }
    }
  });
  if (Object.keys(params).length > 0) {
    return params;
  }
  return null;
};

export const getSelectParamOrder = (
  paramList: string[],
  parameters: { [x: string]: { isPreloaded: boolean; inputType: string } }
) => {
  const orderList: string[] = [];
  const keys = paramList;
  keys.forEach((key) => {
    const { inputType } = parameters[key];
    const { isPreloaded } = parameters[key];
    if (inputType === 'select' && isPreloaded) {
      orderList.push(key);
    }
  });

  return orderList;
};

export { mapParameters };
